import { Card, Form, message } from "antd";
import { useForm } from "antd/es/form/Form";
import { useParams } from "react-router";
import { useEffect } from "react";
import CardFooterAction from "../../../components/CardFooterAction";
import { useGetDetailApi, useStoreUpdateApi } from "../../../hooks/useApi";
import CustomTextInput from "../../../components/CustomTextInput";
import { institutionalAffiliationService } from "../../../services/institutionalAffiliation.service";

export default function InstitutionalAffiliationForm() {
  const { id } = useParams();
  const [form] = useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const { data } = useGetDetailApi({
    id,
    serviceFn: institutionalAffiliationService.findById,
    queryKey: ["institutional-affiliation"],
  });

  const { storeMutation, updateMutation } = useStoreUpdateApi({
    service: institutionalAffiliationService,
    form: form,
    messageApi: messageApi,
    queryKey: "institutional-affiliation",
    route: "/master-data/institutional-affiliation",
  });

  useEffect(() => {
    if (id && data) {
      form.setFieldsValue(data);
    }
  }, [form, id, data]);

  const isPending = storeMutation.isPending || updateMutation.isPending;

  const handleSubmit = (values) => {
    if (!id) {
      storeMutation.mutate(values);
    } else {
      updateMutation.mutate({ id, data: values });
    }
  };

  return (
    <>
      {contextHolder}
      <Card
        title={(id ? "Ubah" : "Tambah") + " Afiliasi / Jejaring Kelembagaan"}
        actions={[
          <CardFooterAction
            key={"submit"}
            route={"/master-data/institutional-affiliation"}
            onClick={form.submit}
            loading={isPending}
            primaryText="Simpan"
            secondaryText="Batal"
          />,
        ]}
      >
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <CustomTextInput
            label="Nama Afiliasi / Jejaring Kelembagaan"
            name="name"
            rules={[
              {
                required: true,
                message: "Nama Afiliasi / Jejaring Kelembagaan harus diisi",
              },
            ]}
            disabled={isPending}
          />
        </Form>
      </Card>
    </>
  );
}
